import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "./context/AppContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderSuccess from "./pages/OrderSuccess";
import About from "./pages/About";
import Tracking from "./pages/Tracking";
import CustomerAuth from "./pages/CustomerAuth";
import MyAccount from "./pages/MyAccount";
import AdminLogin from "./pages/AdminLogin";
import ResetPassword from "./pages/ResetPassword";
import AdminDashboard from "./pages/AdminDashboard";
import PWAInstallBanner from "./components/PWAInstallBanner";
import VisitorHeartbeat from "./components/VisitorHeartbeat";
import "./App.css";

const Shell = ({ children }) => (
  <div className="App flex flex-col min-h-screen bg-ivory">
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
    <PWAInstallBanner />
  </div>
);

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <VisitorHeartbeat />
        <Toaster richColors position="top-right" />
        <Routes>
          <Route path="/" element={<Shell><Home /></Shell>} />
          <Route path="/shop" element={<Shell><Shop /></Shell>} />
          <Route path="/product/:slug" element={<Shell><ProductDetail /></Shell>} />
          <Route path="/cart" element={<Shell><Cart /></Shell>} />
          <Route path="/checkout" element={<Shell><Checkout /></Shell>} />
          <Route path="/order/:id" element={<Shell><OrderSuccess /></Shell>} />
          <Route path="/about" element={<Shell><About /></Shell>} />
          <Route path="/track" element={<Shell><Tracking /></Shell>} />
          <Route path="/account" element={<Shell><MyAccount /></Shell>} />
          <Route path="/login" element={<Shell><CustomerAuth mode="login" /></Shell>} />
          <Route path="/register" element={<Shell><CustomerAuth mode="register" /></Shell>} />
          <Route path="/admin/login" element={<Shell><AdminLogin /></Shell>} />
          <Route path="/reset-password" element={<Shell><ResetPassword /></Shell>} />
          <Route path="/admin" element={<Shell><AdminDashboard /></Shell>} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
